"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Models a simple function queue
 * @param queueSize the maximum allowed queue size
 */
var _defaultMaxFunctionQueueSize = 0x7ffffff; // pseudo-infinity: max 32-bit signed int

var FunctionQueue = function FunctionQueue() {
  var queueSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultMaxFunctionQueueSize;
  var queueBuffer = [];
  var maxQueueSize = Math.max(1, Math.floor(queueSize));
  return {
    /**
     * Adds an item to this queue.
     * @param item  item to add to this queue
     * @returns  true if the item was added; otherwise false (queue is full)
     */
    enqueue: function enqueue(item) {
      if (this.getAvailableSpace() > 0) {
        queueBuffer.push(item);
        return true;
      }

      return false;
    },

    /**
     * Adds multiple items to this queue.
     * @param items  items to add to this queue
     * @returns  true if all the items were added; false if insufficient room
     */
    enqueueMultiple: function enqueueMultiple(items) {
      if (this.getAvailableSpace() >= items.length) {
        queueBuffer = queueBuffer.concat(items);
        return true;
      }

      return false;
    },

    /**
     * Removes and returns an item from this queue.
     * @returns  the item removed; otherwise an undefined is returned
     */
    dequeue: function dequeue() {
      var result;
      if (queueBuffer.length > 0) result = queueBuffer.shift();
      return result;
    },

    /**
     * Removes and returns up to a specified number of items from this queue.
     * @param count the # of items to remove (if more than contained in queue or negative, undefined is returned)
     * @returns  an array of containing the items removed, or undefined if count is out of range.
     */
    dequeueMultiple: function dequeueMultiple(count) {
      var retbuf;

      if (count >= 0) {
        if (queueBuffer.length >= count) {
          retbuf = [];

          if (count > 0) {
            retbuf = queueBuffer.slice(0, count);
            queueBuffer = queueBuffer.slice(count);
          }
        }
      }

      return retbuf;
    },

    /**
     * Removes all items from this queue.
     */
    clear: function clear() {
      queueBuffer = [];
    },

    /**
     * Returns the # of items in this queue.
     * @returns  the # of items in this queue.
     */
    getSize: function getSize() {
      return queueBuffer.length;
    },

    /**
     * Returns the maximum capacity of this queue.
     * @returns  the maximum capacity of this queue.
     */
    getCapacity: function getCapacity() {
      return maxQueueSize;
    },

    /**
     * Returns the space currently available for more items.
     * @returns  the space currently available for more items.
     */
    getAvailableSpace: function getAvailableSpace() {
      return maxQueueSize - queueBuffer.length;
    },
    getQueueBuffer: function getQueueBuffer() {
      return queueBuffer;
    }
  };
};

var _default = FunctionQueue;
exports.default = _default;